


























// Importing components
import BaseSection from '@/ui/BaseSection.vue';

export default {
    name: 'TheWelcomeDescription',
    components: {
        BaseSection,
    },
};
